<template>
  <div class="notifications scrollable -y scrollbar-hidden">

    <transition-group name="fade" mode="out-in">
      <div 
      v-for="(item, key) in toasterItems"
      v-bind:key="key"
      class="toaster-wrapper">
        <div
        v-bind:class="{
          'success': item.status === 'success',
          'info': item.status === 'info',
          'warning': item.status === 'warning',
          'error': item.status === 'error',
        }"
        v-on:click="onClickToaster(key)"
        class="toaster">
          <div class="message">{{item.message}}</div>
        </div>
      </div>
    </transition-group>

  </div>
</template>

<script>
export default {
  name: 'notifications',
  computed: {
    statusGetMyDealer: function () {
      return this.$store.getters.statusGetMyDealer
    },
    statusGetMyProfile: function () {
      return this.$store.getters.statusGetMyProfile
    },
    statusUpdateMyProfile: function () {
      return this.$store.getters.statusUpdateMyProfile
    },
    statusChangeMyPassword: function () {
      return this.$store.getters.statusChangeMyPassword
    },
    statusUploadMyAvatar: function () {
      return this.$store.getters.statusUploadMyAvatar
    },
    statusRegisterMyDealer: function () {
      return this.$store.getters.statusRegisterMyDealer
    },
    statusMfaEnroll: function () {
      return this.$store.getters.statusMfaEnroll
    }
  },
  data: function () {
    return {
      toasterItems: {},
      successTimeout: 1000 * 3,
      infoTimeout: 1000 * 60 * 5,
      warningTimeout: 1000 * 20,
      errorTimeout: 1000 * 60 * 5
    }
  },
  watch: {
    statusGetMyDealer: function (status) {
      if (status === 'successful') {
        this.addNewToaster('success', 'My dealer is loaded', null, 'statusGetMyDealer')
      }
      // } else if (status === 'requested') {
      //   this.addNewToaster('info', 'Loading my dealer', null, 'statusGetMyDealer')
      // } else if (status === 'failed') {
      //   this.addNewToaster('warning', 'Loading my dealer failed', null, 'statusGetMyDealer')
      // }
    },
    statusGetMyProfile: function (status) {
      if (status === 'requested') {
        this.addNewToaster('info', 'Loading my profile', null, 'statusGetMyProfile')
      } else if (status === 'successful') {
        this.addNewToaster('success', 'My profile is loaded', null, 'statusGetMyProfile')
      } else if (status === 'failed') {
        this.addNewToaster('warning', 'Loading my profile failed', null, 'statusGetMyProfile')
      }
    },
    statusUpdateMyProfile: function (status) {
      if (status === 'requested') {
        this.addNewToaster('info', 'Updating my profile', null, 'statusUpdateMyProfile')
      } else if (status === 'successful') {
        this.addNewToaster('success', 'My profile is updated', null, 'statusUpdateMyProfile')
      } else if (status === 'failed') {
        this.addNewToaster('warning', 'Updating my profile failed', null, 'statusUpdateMyProfile')
      }
    },
    statusChangeMyPassword: function (status) {
      if (status === 'requested') {
        this.addNewToaster('info', 'Changing my password', null, 'statusChangeMyPassword')
      } else if (status === 'successful') {
        this.addNewToaster('success', 'My password is changed', null, 'statusChangeMyPassword')
      } else if (status === 'failed') {
        this.addNewToaster('warning', 'Changing my password failed', null, 'statusChangeMyPassword')
      }
    },
    statusUploadMyAvatar: function (status) {
      if (status === 'requested') {
        this.addNewToaster('info', 'Uploading my picture', null, 'statusUploadMyAvatar')
      } else if (status === 'successful') {
        this.addNewToaster('success', 'My picture is uploaded', null, 'statusUploadMyAvatar')
      } else if (status === 'failed') {
        this.addNewToaster('warning', 'Uploading my picture failed', null, 'statusUploadMyAvatar')
      }
    },
    statusRegisterMyDealer: function (status) {
      if (status === 'requested') {
        this.addNewToaster('info', 'Registering my dealer', null, 'statusRegisterMyDealer')
      } else if (status === 'successful') {
        this.addNewToaster('success', 'My dealer is registered', null, 'statusRegisterMyDealer')
      } else if (status === 'failed') {
        this.addNewToaster('warning', 'Registering my dealer failed', null, 'statusRegisterMyDealer')
      }
    },
    statusMfaEnroll: function (status) {
      if (status === 'successful') {
        this.addNewToaster('success', 'Authenticator app registered', null, 'statusMfaEnroll')
      }
    }
  },
  methods: {
    addNewToaster: function (status, message, action, key) {
      if (key in this.toasterItems) {
        if (this.toasterItems[key].hide$t) {
          clearTimeout(this.toasterItems[key].hide$t)
          this.toasterItems[key].hide$t = null
        }
      }
      this.$set(this.toasterItems, key, {
        status: status,
        message: message,
        action: action,
        hide$t: null
      })
      let timeout = status === 'success' ? this.successTimeout
        : status === 'info' ? this.infoTimeout
          : status === 'warning' ? this.warningTimeout
            : status === 'error' ? this.errorTimeout : null
      this.toasterItems[key].hide$t = setTimeout(() => {
        this.hideToaster(key)
      }, timeout)
    },
    onClickToaster: function (key) {
      if (this.toasterItems[key].action) {
        this.toasterItems[key].action()
      }
      this.hideToaster(key)
    },
    hideToaster: function (key) {
      this.$delete(this.toasterItems, key)
    }
  }
}
</script>

<style scoped>
.notifications {
  /* position */
  position: absolute;
  right: 6px;
  top: 6px;
  z-index: 1000;
  /* size */
  max-width: 280px;
  width: 100%;
  max-height: calc(100% - 6px);
}
.notifications .toaster {
  /* common */
  font-size: 16px;
  color: #fefefe;
  opacity: 0.8;
  /* style */
  box-shadow: 0 0 12px #333;
  border-radius: 3px;
  background-position: 15px center;
  background-repeat: no-repeat;
  /* size */
  padding: 15px 15px 15px 50px;
  overflow: hidden;
  margin: 0 0 6px;
  /* position */
  position: relative;
  /* mouse */
  pointer-events: auto;
  cursor: pointer;
}
.notifications .toaster:hover {
  /* common */
  opacity: 1;
}
.notifications .toaster.success {
  /* style */
  background-color: rgb(81, 163, 81);
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADsSURBVEhLY2AYBfQMgf///3P8+/evAIgvA/FsIF+BavYDDWMBGroaSMMBiE8VC7AZDrIFaMFnii3AZTjUgsUUWUDA8OdAH6iQbQEhw4HyGsPEcKBXBIC4ARhex4G4BsjmweU1soIFaGg/WtoFZRIZdEvIMhxkCCjXIVsATV6gFGACs4Rsw0EGgIIH3QJYJgHSARQZDrWAB+jawzgs+Q2UO49D7jnRSRGoEFRILcdmEMWGI0cm0JJ2QpYA1RDvcmzJEWhABhD/pqrL0S0CWuABKgnRki9lLseS7g2AlqwHWQSKH4oKLrILpRGhEQCw2LiRUIa4lwAAAABJRU5ErkJggg==)!important;
}
.notifications .toaster.info {
  /* style */
  background-color: rgb(47, 150, 180);
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVEhLtZa9SgNBEMc9sUxxRcoUKSzSWIhXpFMhhYWFhaBg4yPYiWCXZxBLERsLRS3EQkEfwCKdjWJAwSKCgoKCcudv4O5YLrt7EzgXhiU3/4+b2ckmwVjJSpKkQ6wAi4gwhT+z3wRBcEz0yjSseUTrcRyfsHsXmD0AmbHOC9Ii8VImnuXBPglHpQ5wwSVM7sNnTG7Za4JwDdCjxyAiH3nyA2mtaTJufiDZ5dCaqlItILh1NHatfN5skvjx9Z38m69CgzuXmZgVrPIGE763Jx9qKsRozWYw6xOHdER+nn2KkO+Bb+UV5CBN6WC6QtBgbRVozrahAbmm6HtUsgtPC19tFdxXZYBOfkbmFJ1VaHA1VAHjd0pp70oTZzvR+EVrx2Ygfdsq6eu55BHYR8hlcki+n+kERUFG8BrA0BwjeAv2M8WLQBtcy+SD6fNsmnB3AlBLrgTtVW1c2QN4bVWLATaIS60J2Du5y1TiJgjSBvFVZgTmwCU+dAZFoPxGEEs8nyHC9Bwe2GvEJv2WXZb0vjdyFT4Cxk3e/kIqlOGoVLwwPevpYHT+00T+hWwXDf4AJAOUqWcDhbwAAAAASUVORK5CYII=)!important;
}
.notifications .toaster.warning {
  /* style */
  background-color: rgb(248, 148, 6);
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGYSURBVEhL5ZSvTsNQFMbXZGICMYGYmJhAQIJAICYQPAACiSDB8AiICQQJT4CqQEwgJvYASAQCiZiYmJhAIBATCARJy+9rTsldd8sKu1M0+dLb057v6/lbq/2rK0mS/TRNj9cWNAKPYIJII7gIxCcQ51cvqID+GIEX8ASG4B1bK5gIZFeQfoJdEXOfgX4QAQg7kH2A65yQ87lyxb27sggkAzAuFhbbg1K2kgCkB1bVwyIR9m2L7PRPIhDUIXgGtyKw575yz3lTNs6X4JXnjV+LKM/m3MydnTbtOKIjtz6VhCBq4vSm3ncdrD2lk0VgUXSVKjVDJXJzijW1RQdsU7F77He8u68koNZTz8Oz5yGa6J3H3lZ0xYgXBK2QymlWWA+RWnYhskLBv2vmE+hBMCtbA7KX5drWyRT/2JsqZ2IvfB9Y4bWDNMFbJRFmC9E74SoS0CqulwjkC0+5bpcV1CZ8NMej4pjy0U+doDQsGyo1hzVJttIjhQ7GnBtRFN1UarUlH8F3xict+HY07rEzoUGPlWcjRFRr4/gChZgc3ZL2d8oAAAAASUVORK5CYII=)!important;
}
.notifications .toaster.error {
  /* style */
  background-color: rgb(189, 54, 47);
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAHOSURBVEhLrZa/SgNBEMZzh0WKCClSCKaIYOED+AAKeQQLG8HWztLCImBrYadgIdY+gIKNYkBFSwu7CAoqCgkkoGBI/E28PdbLZmeDLgzZzcx83/zZ2SSXC1j9fr+I1Hq93g2yxH4iwM1vkoBWAdxCmpzTxfkN2RcyZNaHFIkSo10+8kgxkXIURV5HGxTmFuc75B2RfQkpxHG8aAgaAFa0tAHqYFfQ7Iwe2yhODk8+J4C7yAoRTWI3w/4klGRgR4lO7Rpn9+gvMyWp+uxFh8+H+ARlgN1nJuJuQAYvNkEnwGFck18Er4q3egEc/oO+mhLdKgRyhdNFiacC0rlOCbhNVz4H9FnAYgDBvU3QIioZlJFLJtsoHYRDfiZoUyIxqCtRpVlANq0EU4dApjrtgezPFad5S19Wgjkc0hNVnuF4HjVA6C7QrSIbylB+oZe3aHgBsqlNqKYH48jXyJKMuAbiyVJ8KzaB3eRc0pg9VwQ4niFryI68qiOi3AbjwdsfnAtk0bCjTLJKr6mrD9g8iq/S/B81hguOMlQTnVyG40wAcjnmgsCNESDrjme7wfftP4P7SP4N3CJZdvzoNyGq2c/HWOXJGsvVg+RA/k2MC/wN6I2YA2Pt8GkAAAAASUVORK5CYII=)!important;
}
.notifications .toaster .message {
  /* size */
  padding: 0;
  /* text */
  word-wrap: break-word;
  text-align: left;
}


</style>



// WEBPACK FOOTER //
// src/pages/Account/Notifications.vue